// Supported page locales — mirrors backend SUPPORTED_LOCALES
// (landing_pages/models.py). Phase 1: European LTR set. Keep the two in sync.
export const SUPPORTED_LOCALES = ['en', 'fr', 'pt', 'de', 'es'];

export const LOCALE_NAMES = {
  en: 'English',
  fr: 'Français',
  pt: 'Português',
  de: 'Deutsch',
  es: 'Español',
};

export const LOCALE_SHORT = {
  en: 'EN', fr: 'FR', pt: 'PT', de: 'DE', es: 'ES',
};

export const localeName = (code) => LOCALE_NAMES[code] || code;
export const localeShort = (code) => LOCALE_SHORT[code] || String(code).toUpperCase();

// sessionStorage key recording a visitor's explicit language choice for a page.
export const langChoiceKey = (slug) => `pglang:${slug}`;

/**
 * Best match between a visitor's preferred languages and what a page offers.
 * navigator.languages looks like ['fr-FR','fr','en-US','en']; we compare on the
 * base subtag ('fr'), first match wins. Returns null if nothing matches.
 */
export function pickBrowserLocale(preferred = [], available = []) {
  const set = new Set(available);
  for (const pref of preferred) {
    const base = String(pref || '').toLowerCase().split('-')[0];
    if (set.has(base)) return base;
  }
  return null;
}

/**
 * Decide whether the bare /p/{slug} URL should redirect to a locale.
 *
 * Returns a locale to send the visitor to, or null to stay on the default.
 * Honours an explicit prior choice (`stored`) over browser detection, so
 * clicking "EN" is never overridden by a French browser. Only ever redirects
 * to a NON-default locale the page actually offers.
 */
export function resolveInitialLocale({ locales = [], defaultLocale = 'en', stored = null, browserLangs = [] }) {
  if (locales.length <= 1) return null;
  const choice = stored || pickBrowserLocale(browserLangs, locales);
  if (choice && choice !== defaultLocale && locales.includes(choice)) return choice;
  return null;
}
